import update from 'immutability-helper';
import { handleActions } from 'redux-actions';
import Constants from 'constants/actions';
import {
  CRM_SURVEYS_SHOW_CONNECT_SURVEYS,
  CRM_SURVEYS_SHOW_IN_MENU,
  CRM_SURVEYS_TABS,
} from 'constants/featureFlags';
import { isEmpty, get } from 'lodash';

const defaultTimeZone = 'US/Eastern';

const initialState = {
  accessErrorType: null,
  user: {},
  featureFlags: {
    [CRM_SURVEYS_SHOW_CONNECT_SURVEYS]: false,
    [CRM_SURVEYS_SHOW_IN_MENU]: false,
    [CRM_SURVEYS_TABS]: false,
  },
};

export default handleActions(
  {
    [Constants.SET_USER]: (state, { payload: user }) =>
      update(state, {
        user: { $set: user },
      }),
    [Constants.SET_ACCESS_ERROR_TYPE]: (state, { payload }) =>
      update(state, {
        accessErrorType: { $set: payload },
      }),
    [Constants.SET_FEATURE_FLAG]: (state, { payload }) =>
      update(state, {
        featureFlags: { $set: payload },
      }),
  },
  initialState,
);

export const getUser = (state) => state.user;

export const getUserRoles = (state) => get(state, ['__global/roles', 'data'], []);

export const getUserLicense = (state) => get(state, ['__global/licenses', 'data'], []);

export const getUserId = (state) => {
  const user = getUser(state);
  return user ? user.id : null;
};

export const isUserInitialized = (state) => !isEmpty(state.user);

export const getAccessErrorType = (state) => state.accessErrorType;

export const getUserTimeZone = (state) => {
  const user = getUser(state);
  return user ? user.timeZone : defaultTimeZone;
};

export const getAllFeatureFlags = (state) => get(state, ['app', 'featureFlags']);

export const getFeatureFlagValue = (state, featureFlag) => get(state, ['app', 'featureFlags', featureFlag]);
